module.exports = __webpack_public_path__ + "img/iconit.71be2ed2.png";